import { Grid, makeStyles, Typography } from "@material-ui/core";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect, useRef, useState } from "react";
import Jobs from "../../actions/Jobs";
import { isAuth } from "../../actions/auth";
import { Alert } from "@material-ui/lab";
import { Document, Page, pdfjs } from "react-pdf";
import Popup from "../customHelpers/Popup";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const initialFValues = {
    body: "",
    title: "",
    author: "",
    editing: false,
};

const QuillModules = {
    toolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        ["image", "video", "link"],
        [{ header: 1 }, { header: 2 }, { header: [1, 2, 3, 4, 5, 6, false] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        [{ size: ["small", "large", "huge", false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ["clean"],
    ],
};

const QuillFormats = [
    "background", "bold", "color", "font", "code", "italic", "link", "size",
    "strike", "script", "underline", "blockquote", "header", "indent", "list",
    "align", "direction", "code-block", "formula", "image", "video",
];

const useStyles = makeStyles((theme) => ({
    image: {
        height: "250px",
        width: "100%",
        objectFit: "cover",
        margin: "10px 0px",
        borderRadius: "8px",
    },
}));

const JobForm = ({
    NotifyMessage,
    setOpenPopup,
    recordForEdit,
    getAllJobs,
    update,
    isCompany = false,
    companyId = null,
}) => {
    const classes = useStyles();
    const { addJob, updateJob, userAddJob } = Jobs();

    useEffect(() => {
        if (recordForEdit != null) {
            setValues({
                ...recordForEdit,
            });
        }
    }, [recordForEdit]);

    const validate = (fieldValues = values) => {
        const temp = { ...errors };
        if ("body" in fieldValues)
            temp.body = fieldValues.body.length !== 0 && fieldValues.body !== "<p><br></p>" ? "" : "Job description is required.";
        if ("title" in fieldValues)
            temp.title = fieldValues.title.length !== 0 ? "" : "Title is required.";
        if ("author" in fieldValues)
            temp.author = fieldValues.author.length !== 0 ? "" : "Author/Company name is required.";


        setErrors({ ...temp });
        if (fieldValues === values) return Object.values(temp).every((x) => x === "");
    };

    const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
        useForm(recordForEdit || initialFValues, true, validate);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;

        const jobData = {
            title: values.title,
            body: values.body,
            author: values.author,
        };

        if (isCompany) {
            const user = isAuth();
            if (user?.email) jobData.companyEmail = user.email;
            if (user?.name) jobData.companyName = user.name;
            if (user?.description) jobData.companyDescription = user.description;
            if (user?.logo) jobData.companyLogo = user.logo;
        }

        setValues({ ...values, submitting: true });

        const action = values.editing
            ? updateJob(jobData, values.Id)
            : (isCompany ? userAddJob(jobData, companyId || "self") : addJob(jobData));

        action.then((data) => {
            setValues({ ...values, submitting: false });
            if (data.err) {
                NotifyMessage({ message: data.err, type: "error" });
            } else {
                NotifyMessage({ message: data.message, type: "success" });
                setOpenPopup(false);
                resetForm();
                getAllJobs();
            }
        });
    };

    const handleBody = (name, value) => ({
        target: { name, value },
    });

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Controls.Input
                        name="title"
                        label="Job Title"
                        value={values.title}
                        onChange={handleInputChange}
                        error={errors.title}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Controls.Input
                        name="author"
                        label="Company Name / Author"
                        value={values.author}
                        onChange={handleInputChange}
                        error={errors.author}
                    />
                </Grid>


                <Grid item xs={12}>
                    <ReactQuill
                        modules={QuillModules}
                        formats={QuillFormats}
                        value={values.body}
                        placeholder="Describe the job requirements and responsibilities..."
                        onChange={(e) => handleInputChange(handleBody("body", e))}
                        theme="snow"
                    />
                    {errors.body && <Alert severity="error">{errors.body}</Alert>}
                </Grid>

                <Grid item xs={12}>
                    <Controls.Button
                        disabled={values.submitting}
                        text={values.editing ? (values.submitting ? "Saving..." : "Save Changes") : (values.submitting ? "Posting..." : "Post Job")}
                        type="submit"
                    />
                </Grid>
            </Grid>
        </Form>
    );
};

export default JobForm;
